import Banner from './../banner/Banner';
import Bottons from './../bottons/Bottons';
import MainContent from './../main/MainContent';
import Footer from './../footer/Footer';
import UserAppContext from '../../hook/UserAppContext';

const Container = () => {

      const {user} = UserAppContext()

      if(user.length === 0) return

      return (
            <>
            <Banner />
            <Bottons />
            <MainContent />
            <Footer />
            </>
      )
}

export default Container;